/* Customer Buildings gallery: fetches approved submissions from the Team
 * Portal public API and renders a sortable, paged card grid. */
(function () {
  "use strict";
  var root = document.querySelector(".crb-gallery");
  if (!root) return;
  var API = (root.getAttribute("data-api-base") || "").replace(/\/+$/, "");
  var grid = document.getElementById("cg-grid");
  var moreBtn = document.getElementById("cg-more");
  var sortSel = document.getElementById("cg-sort");
  var countEl = document.getElementById("cg-count");
  var PER = 24;
  var state = { sort: "newest", page: 1, total: 0, loading: false };

  var params = new URLSearchParams(location.search);
  if (params.get("sort")) {
    state.sort = params.get("sort");
    sortSel.value = state.sort;
    if (sortSel.value !== state.sort) { state.sort = "newest"; sortSel.value = "newest"; }
  }

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  function card(item) {
    var a = document.createElement("a");
    a.className = "crb-gallery__card";
    a.href = "/pages/customer-building?b=" + encodeURIComponent(item.handle);
    var meta = [item.size, item.style].filter(Boolean).join(" ");
    var place = [item.city, item.state].filter(Boolean).join(", ");
    a.innerHTML =
      (item.image
        ? '<img loading="lazy" src="' + esc(item.image) + '" alt="' + esc(item.title) + '">'
        : '<span class="crb-gallery__card-noimg" aria-hidden="true">🏠</span>') +
      '<span class="crb-gallery__card-body">' +
      '<span class="crb-gallery__card-title">' + esc(item.title) + "</span>" +
      '<p class="crb-gallery__card-meta">' + esc([meta, place].filter(Boolean).join(" · ")) + "</p>" +
      (item.use ? '<p class="crb-gallery__card-use">' + esc(item.use) + "</p>" : "") +
      (item.videoCount ? '<span class="crb-gallery__badge">🎥 Video tour</span>' : "") +
      "</span>";
    return a;
  }

  function load(reset) {
    if (state.loading) return;
    state.loading = true;
    moreBtn.disabled = true;
    if (reset) { state.page = 1; grid.innerHTML = ""; }
    fetch(API + "/api/share/public/list?sort=" + encodeURIComponent(state.sort) + "&page=" + state.page + "&per=" + PER)
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (!json.ok) throw new Error();
        state.total = json.total;
        json.items.forEach(function (it) { grid.appendChild(card(it)); });
        var shown = grid.children.length;
        countEl.textContent = state.total ? "Showing " + shown + " of " + state.total + " buildings" : "";
        document.getElementById("cg-empty").hidden = state.total !== 0;
        moreBtn.hidden = shown >= state.total;
        moreBtn.disabled = false;
        if (window.dataLayer && state.page === 1) window.dataLayer.push({ event: "customer_building_gallery_view" });
      })
      .catch(function () {
        document.getElementById("cg-error").hidden = false;
      })
      .then(function () { state.loading = false; });
  }

  sortSel.addEventListener("change", function () {
    state.sort = sortSel.value;
    var url = new URL(location.href);
    url.searchParams.set("sort", state.sort);
    history.replaceState(null, "", url);
    load(true);
    if (window.dataLayer) window.dataLayer.push({ event: "customer_building_gallery_sort", sort: state.sort });
  });
  moreBtn.addEventListener("click", function () {
    state.page += 1;
    load(false);
  });

  load(true);
})();
